import { useEffect, useRef } from 'react';
// tracks whether current render is first render or not
export const useIsMount = () => {
  const isMountRef = useRef(true);
  useEffect(() => {
    isMountRef.current = false;
  }, []);
  return isMountRef.current;
};
